import { UliItemActionParams } from '../models/uli-item-overview.model';

export class UliItemSetUliId {
  public static readonly type = '[UliItem] Set Uli';

  constructor(public payload: UliItemActionParams) {}
}

export class UliItemInitialState {
  public static readonly type = '[UliItem] Set Initial State';
}
